module.exports = {
  book_session : 'Book Your Session',
  now_showing: 'Now showing',
  booking: 'Booking',
  details: 'ABOUT',
  logout: 'Logout',
  pick: 'Once you are there you can pick whatever you like to see',
  in_session: 'Top Picks:',
  select_experience: 'SELECT YOUR VR EXPERIENCE',
  select_date: 'SELECT YOUR SESSION DATE',
  select_session: 'SELECT YOUR SESSION TIME',
  select_places: 'BOOK YOUR NUMBER OF SEAT ',
  your_booking: 'YOUR BOOKING',
  select_phrase: 'Please Select Date, Time and Number Of Seats',
  total_payment: 'TOTAL',
  check_out: 'Check Out',
  fill_require: '*Fill in the required info in order to check out',
  request_code: 'Request Code',
  user_logout: 'Logout',
  cancel: 'Cancel',
  logout_verification: 'Are your sure you want to logout',
  verify_account: 'VERIFY YOUR ACCOUNT',
  voucher_code: 'voucher code*',
  payment_sbtitle: 'Please fill in your credentials to create an account with us',
  p1: 'First name*',
  p2: 'Phone Number*',
  p3: 'Email*',
  p4: '* 4 digits code',
  p5: '* Enter voucher code',
  p6: 'Email address*',
  p7: 'Last name*',
  select_confirm: '*By click Book Session you will get all 4 PACKS',
  address: 'ADDRESS',
  address_loc_p1: 'Auguste Pacha Adib - Sirian street, lot 1687',
  address_loc_p2: 'Ashrafieh - Beirut',
  email: 'EMAIL',
  email_add: 'Hello@bbangstudios.com',
  phone: 'PHONE',
  phone_num: '+961 76 083 973',
  subscribe: 'SUBSCRIBE',
  sub_succ: 'You have successfully subscribed to the bigbang newsletter.',
  send: 'Send',
  subscribe_sbtitle: 'Subscribe and be the first to receive our most recent announcements',
  err1: 'Please Select Date, Time and Number Of Seats',
  err2: 'Please Fill In A Valid Email',
  err3: 'Please Fill In The Form',
  err4: 'Please Enter A Valid Code',
  err5: 'Please Enter A Valid Phone Number',
  err6: 'This option is not available, please select a different option',
  err7: 'Sorry, Interactive experience is fully-booked, Please try again another day.',
  err8: 'Sorry, Theatre experience is fully-booked, Please try again another day.',
  refund_pol: 'REFUND POLICY FOR BIG BANG SERVICES',
  home_page: 'Home Page',
  pay_app: 'Sorry, Your payment was unsuccessful. No charges were made.',
  pay_suc: 'You have completed your online booking and payment successfully. We’ll send you a confirmation shortly.',
  retry: 'Retry',
  user_continue: 'Continue',
  verification_ph: '*Create your account here in order to checkout.',
  checkout_ph: '*Checkout as ',
  payment_process: 'PAYMENT PROCESS',
  loading: 'LOADING',
  loading_submsg1: 'Your booking is at its final stages, please wait!',
  sorry: 'WE’RE SORRY!',
  conf_err_submsg1: 'We were unable to confirm your booking.',
  conf_err_submsg2: 'We promise to give you a call soon and fix this issue, please refrain from booking again until then.',
  conf_err_submsg3: 'You can call us on +961 76 083 973 so we can help you fix this issue immediately.',
  success: 'SUCCESS',
  success_submsg1: 'Your online booking with us was successful. You submitted a booking for:',
  success_submsg2: 'You will receive a confirmation email to the address below:',
  success_submsg3: 'The reference number is:',
  token_noti: 'Please insert the verification code that was sent to your mobile device',
  payment_method_title: 'SELECT PAYMENT METHOD',
  payment_method1: 'Bigbang payments go through Payfort',
  pay_method1: 'PAY WITH CARD',
  payment_method2: 'Unless you have a voucher, then please enter the code below',
  pay_method2: 'PAY WITH VOUCHER',
  thank_you: 'THANK YOU!',
  done: 'DONE'
}



// WEBPACK FOOTER //
// ./src/lang/en/messages.js